import { API, API_GET } from "../../config";


export const GetContacts = () => {
  return API_GET(API.GetContact);
};
